export const service = {
  serviceAndRate: "Services & Rates",
  skillAndRates: "Skills & Rates",
  vetted: "Vetted",
  "Interpretation-online": "Online",
  "Interpretation-on-site": "Hourly Rate",
  "Desktop Publishing (DTP)-rate-per slide": "Hourly Rate",
  "Desktop Publishing (DTP)-rate-per hour": "Hourly Rate",
  "Interpretation-overtime online": "Overtime",
  "Interpretation-online half a day": "Half Day (4 hours)",
  "Interpretation-online full day": "Full Day (8 hours)",
  "Interpretation-per hour": "Hourly Rate",
  "Interpretation-overtime on-site": "Overtime",
  "Interpretation-on-site half a day": "Half Day (4 hours)",
  "Interpretation-on site full day": "Full Day (8 hours)",
  "USD/online": "per hour",
  "USD/on-site": "per hour",
  "USD/overtime on-site": "per hour",
  "USD/per slide": "per hour",
  "USD/per hour": "per hour",
  "USD/overtime online": "per hour",
  "USD/on-site half a day": "per half Day",
  "USD/online half a day": "per half Day",
  "USD/online full day": "per full Day",
  "USD/on site full day": "per full Day",
  "Interpretation-rate-online": "Hourly Rate for Online Interpreting",
  "Interpretation-rate-on-site": "Hourly Rate for On-site Interpreting",
  "Interpretation-rate-overtime online":
    "Overtime Rate for Online Interpreting",
  "Interpretation-rate-online half a day":
    "Half Day Rate for Online Interpreting (4h)",
  "Interpretation-rate-online full day":
    "Full Day Rate for Online Interpreting (8h)",
  "Interpretation-rate-per hour": "Hourly Rate for Interpreting",
  "Interpretation-rate-overtime on-site":
    "Overtime Rate for On-site Interpreting",
  "Interpretation-rate-on-site half a day":
    "Half Day Rate for On-site Interpreting (4h)",
  "Interpretation-rate-on site full day":
    "Full Day Rate for On-site Interpreting (8h)",
  // "per hour": "Hour",
  "per slide": "Slide",
  perDay: "per day",
  perHour: "per hour",

  "subTitle-per slide L1": "Rate Per slide L1",
  "rate-per slide L1": "Rate Per slide L1",
  "per slide L1": "",
  "Capacity-per slide L1": "Capacity slides per day L1",
  "subTitle-per slide L2": "Rate Per slide L2",
  "rate-per slide L2": "Rate Per slide L2",
  "per slide L2 Desktop Publishing (DTP)": "Desktop Publishing (DTP) L2",
  "per slide L1 Desktop Publishing (DTP)": "Desktop Publishing (DTP) L1",
  "per slide L0 Desktop Publishing (DTP)": "Desktop Publishing (DTP)",
  "Capacity-per slide L2": "Capacity slides per day L2",
  "Editing-rate-per word": "rate",
  "Editing-rate-per hour": "capacity",
  "Capacity-per word": "Please specify your capacity in words per day",
  "Capacity-per hour": "Please specify your capacity in hours per day",
  "Capacity-LQE Review-per hour": "Please specify your capacity in hours",
  "Capacity-per minute": "Please specify your capacity in minutes per day",
  rate: "Rate",
  capacity: "Capacity",
  onsite: "Onsite",
  online: "Online",
  "per page Typing": "Typing",
  "per word Transcreation": "Transcreation per word",
  "per hour Transcreation": "Transcreation per hour",
  "per word Editing": "Editing per word",
  "per hour Editing": "Editing per hour",
  "day": "day",
  "hour": "hour",
  "per word-Editing": "per word",
  "per hour-Editing": "per hour",
  "per hour-Editing-placeHolder": "Your capacity (hour/day)",
  "LQE Review-per hour": "Your capacity (hour)",
  "per word-Transcreation": "per word",
  "per hour-Transcreation": "per hour",
  "per page-Typing": "per page",
  "Desktop Publishing (DTP)-0": "Capacity slides per day",
  "Desktop Publishing (DTP)-1": "Capacity slides per day L1",
  "Desktop Publishing (DTP)-2": "Capacity slides per day L2",
  "Capacity-per page": "Please specify your capacity in pages per day",
  word:'Word',
  'per slide L0-Desktop Publishing (DTP)':'per slide',
  'per slide L1-Desktop Publishing (DTP)':'per slide',
  'per slide L2-Desktop Publishing (DTP)':'per slide',
'char-per page':'page',
'char-per word':'word',
'char-per hour':'hour',
'char-per slide L0':'slide',
'char-per slide L1':'slide',
'char-per slide L2':'slide',
};
